import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';

export const PreviewBanner = ({clientId, clientName}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const handleExit = () => {
        navigate(`/client/${clientId}/monitoring`);
    };

    return (
        <div className="preview-banner">
            <div className="preview-banner-inner">
                <div className="preview-banner-left">
                    <FaIcon iconName="eye"/>
                    <span className="preview-banner-text">
                        {t('preview.banner_title', {name: clientName || ''})}
                    </span>
                </div>
                <button className="preview-banner-exit" onClick={handleExit}>
                    <FaIcon iconName="xmark"/>
                    {t('preview.exit')}
                </button>
            </div>
        </div>
    );
};
